import React, { useState,useEffect } from "react";
import { AiOutlinePlus } from "react-icons/ai";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { AllServicesHooks, handleDeleteService } from "./hooks/serviceHooks";
import CustomTable from "../universal/CustomTable";
import ConfirmToast from "../universal/ConfirmToast";
import ServiceModal from "./ServiceModal";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const allServicesHeader = [
  { headerName: "Service Name", headerId: "serviceName" },
  { headerName: "Description", headerId: "serviceTitle" },
  { headerName: "Type", headerId: "typeofService" },
  { headerName: "Actions", headerId: "actions" },
];

function AllServices({ church }) {
  const { reloadData, setReloadData, fetchAllServices, dispatch } = AllServicesHooks();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  // ✅ Trigger first data load when church is available
  useEffect(() => {
    if (church?._id) {
      setReloadData((prev) => !prev);
          }
  }, [church?._id]);

  return (
    <>
    {
      church?
    <div className="App bg-[#191919]">
      <div className="relative p-4">
        <div className="flex gap-4 absolute right-4 mt-2">
          <button
            onClick={() => setIsModalOpen(true)}
            className="flex items-center gap-2 text-[13px] text-yellowish border px-4 py-2 border-yellowish bg-blackish rounded-xl"
          >
            <AiOutlinePlus /> Add Service
          </button>
        </div>

        {!isModalOpen && (
          <CustomTable
            searchFor="Services"
            heightDesktop="h-[72vh]"
            width="w-24"
            nthChildWidth="[&>*:nth-child(1)]:w-40 [&>*:nth-child(2)]:w-40 [&>*:nth-child(3)]:w-32 [&>*:nth-child(4)]:w-32"
            notificationTable={true}
            headers={allServicesHeader}
            data={[]}
            customDataFetch={true}
            customDataFetchFunction={(page, limit, searchCriteria, callback) =>
              fetchAllServices(dispatch, page, limit, searchCriteria, callback, church?._id)
            }
            reloadData={reloadData}
            setReloadData={setReloadData}
            reverseTable={true}
            handleDeleteClick={(row) => {
              confirmAlert({
                customUI: ({ onClose }) => (
                  <ConfirmToast
                    title="Are you sure?"
                    message="You want to delete this service?"
                    onClose={onClose}
                    onSuccess={() => {
                      handleDeleteService(dispatch, church?._id, row.serviceObjId, (res) => {
                        if (res.type === 1) {
                          toast.success("Service deleted successfully!");
                          setReloadData((prev) => !prev);
                        } else {
                          toast.error("Failed to delete service!");
                        }
                        onClose();
                      });
                    }}
                  />
                ),
              });
            }}


            handleEditClick={(row) => {
              setSelectedRow(row);
                            setIsModalOpen(true);
            }}
          />
        )}
      </div>

      <ServiceModal
        church={church}
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          setSelectedRow(null);
          setReloadData((prev) => !prev); // ✅ refresh after close too
        }}
        rowData={selectedRow}
      />
    </div>
    :
    <div className="w-full h-full flex items-center justify-center text-gray-400 ">
        <p>Add Church/Ministry/Channel First</p>

    </div>
}
    </>
  );
}

export default AllServices;
